export const CURRENT_DEPLOYMENT_VERSION = process.env.VUE_APP_DEPLOYMENT_VERSION || 'development';
export const DEPLOYMENT_VERSION_CHECK_INTERVAL_MS = 60 * 1000;

function deploymentVersionUrl() {
  const baseUrl = String(process.env.BASE_URL || '/').replace(/\/?$/, '/');
  return `${baseUrl}version.json?_=${Date.now()}`;
}

export async function fetchDeploymentVersion(fetchImpl = window.fetch.bind(window)) {
  const response = await fetchImpl(deploymentVersionUrl(), {
    cache: 'no-store',
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error(`Versionsprüfung fehlgeschlagen (${response.status})`);
  }

  const payload = await response.json();
  return String(payload?.version || '').trim();
}
